import React from 'react';
import { Button, ButtonColor } from 'ui-builder';

interface RegisteredNotLinkedStatusProps {
  userEmail: string;
  onGoToLogin: () => void;
}

export default function RegisteredNotLinkedStatus({
  userEmail,
  onGoToLogin
}: RegisteredNotLinkedStatusProps) {
  return (
    <div>
      <i
        className="fa fa-link"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#ffc107' }}
      />
      <h2 style={{ marginBottom: '1rem', color: '#ffc107' }}>Account Not Linked</h2>
      <p style={{ color: '#666', marginBottom: '1rem' }}>
        You have an account with email <strong>{userEmail}</strong>, but it's not linked with Google.
      </p>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        Please sign in with your email and password to access your account.
      </p>
      <Button
        text="Sign In with Password"
        color={ButtonColor.GREEN}
        onClick={onGoToLogin}
      />
    </div>
  );
}